import { render, staticRenderFns } from "./new-supplier.vue?vue&type=template&id=7da33fe8&scoped=true&"
import script from "./new-supplier.vue?vue&type=script&lang=js&"
export * from "./new-supplier.vue?vue&type=script&lang=js&"
import style0 from "./new-supplier.vue?vue&type=style&index=0&id=7da33fe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da33fe8",
  null
  
)

export default component.exports